import { render, staticRenderFns } from "./OverallDataMinimal.vue?vue&type=template&id=0911a6ad&"
import script from "./OverallDataMinimal.vue?vue&type=script&lang=js&"
export * from "./OverallDataMinimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports